import React from 'react';
import { useHttpRequest } from 'src/utils/httpClient';
import useAccessToken from 'src/auth/useAccessToken';
import { userInfoFields } from 'src/reducers/authReducer';
import { useDispatch } from 'react-redux';
import { USER_INFO_LOADED } from 'src/actions/authActions';

const UserDataProvider = () => {
    const graphAccessToken = useAccessToken(['User.Read']);
    const dispatch = useDispatch();

    const { mutate: fetchUserData } = useHttpRequest((accessToken) => ({
        method: 'GET',
        endpoint: 'https://graph.microsoft.com/v1.0/me',
        headers: {
            Authorization: `Bearer ${accessToken}`
        },
        params: {
            $select: userInfoFields.join(',')
        }
    }));

    React.useEffect(() => {
        const fetchData = async () => {
            const { payload, error } = await fetchUserData(graphAccessToken);
            if (!error) {
                dispatch({ type: USER_INFO_LOADED, data: payload });
            }
        };
        if (graphAccessToken) {
            fetchData();
        }
    }, [graphAccessToken, fetchUserData, dispatch]);

    return null;
};

export default UserDataProvider;